import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { HorizontalListData } from 'common';
import { BrokerExData } from '../broker.model';
import { BrokerApiWidgetAdapter } from './broker-api-widget.data';

@Component({
    selector: 'ifb-broker-api-widget',
    templateUrl: './broker-api-widget.component.html',
    providers: [BrokerApiWidgetAdapter],
    standalone: false
})
export class BrokerApiWidgetComponent implements OnChanges {
  @Input()
  broker: BrokerExData;

  @Input()
  canEdit: boolean;

  @Output()
  edit = new EventEmitter<boolean>();

  listItems: HorizontalListData[];

  constructor(private readonly adapter: BrokerApiWidgetAdapter) {}

  ngOnChanges(): void {
    this.listItems = this.adapter.adaptListData();
  }

  update(isChecked: boolean): void {
    this.edit.emit(isChecked);
  }
}
